module.exports = __webpack_public_path__ + "img/screening-empty.e750c75a.svg";